module.exports = __webpack_public_path__ + "img/6.474c7bac.png";